import { http } from 'connex-cds';

export default {
  getAttachment: ({ entityRef, itemRef }) =>
    http.get({ apiName: 'mt', path: `/${entityRef}/ticket-attachments-driver-viewable/${itemRef}` }),
};
